import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactOnScreenTrackVisibility from 'react-on-screen'
import { useTracking } from './track'

export const useTrackImpression = (properties) => {
  const tracker = useTracking()

  useEffect(() => {
    tracker.trackEvent(properties)
  }, []) // [] fire side effect only once!
}

export const TrackImpression = ({ children, eventProperties }) => {
  useTrackImpression(eventProperties)
  return children
}

export const TrackVisibility = ({ children, eventProperties }) => {
  const tracker = useTracking()
  return (
    <ReactOnScreenTrackVisibility partialVisibility once>
      {({ isVisible }) => {
        if (isVisible) tracker.trackEvent(eventProperties)
        return children
      }}
    </ReactOnScreenTrackVisibility>
  )
}

TrackVisibility.propTypes = {
  children: PropTypes.node.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  eventProperties: PropTypes.object.isRequired,
}
